import request from "src/utils/request";
import getOverview from "src/scenes/dashboard/mock-data/overview";
import useDashboardApi from "./use-dashboard-api";

const useOverviewApi = (name) => {
    const requestHandler = (abortController) => {
        return request(`/api/data/fundamentals/v1/${name}`, { abortController });
    };

    return useDashboardApi(
        () => getOverview(),
        ({ abortController }) => requestHandler(abortController),
        undefined,
        `/api/data/fundamentals/v1/${name}`
    );
};

export default useOverviewApi;
